import { Buffer } from 'buffer'

Object.assign(globalThis, { Buffer })

import './style/fonts.css'
import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Root from './Root'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Root />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
